module.exports = __webpack_public_path__ + "static/img/about.157e6e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about.jpg
// module id = UAsQ
// module chunks = 1